// Enumeraciones para el módulo de Calendario de Empleado

/**
 * Estados de solicitud
 */
export const RequestStatus = {
  PENDING: 0,
  APPROVED: 1,
  PAID_ABSENCE: null,
  VACATION: 6
}
